import { RouteObject } from 'react-router-dom';
import AdminSrDashboardWrapper from '@/modules/admin-dashboard/components/AdminSrDashboardWrapper.tsx';
import AdminEntities from '@/modules/admin-dashboard/pages/AdminEntities.tsx';
import AdminIssuers from '@/modules/admin-dashboard/pages/AdminIssuers.tsx';
import AdminRegisters from '@/modules/admin-dashboard/pages/AdminRegisters.tsx';

export const adminDashboardPaths = {
  static: {
    registers: '/admin/registers',
    issuers: '/admin/issuers',
    entities: '/admin/holders',
  },
};

export const getAdminDashboardRoutes = () => {
  const router: RouteObject[] = [
    {
      element: <AdminSrDashboardWrapper />,
      children: [
        { path: adminDashboardPaths.static.issuers, element: <AdminIssuers /> },
        { path: adminDashboardPaths.static.entities, element: <AdminEntities /> },
        { path: adminDashboardPaths.static.registers, element: <AdminRegisters /> },
      ],
    },
  ];

  return router;
};
